import authLocalFe from '@blaze-cms/plugin-auth-local-fe';
import ecommerceComponents from '@blaze-cms/plugin-ecommerce-components';
import ecommerceGtm from '@blaze-cms/plugin-ecommerce-gtm-fe';

import examplePlugin from './blaze-plugins/example';
import ppContent from './blaze-plugins/pp-components';
import listQueryVariables from './blaze-plugins/list-query-variables';

export default function buildConfig(config) {
  // To set custom plugins into the project.
  config.plugins.set(examplePlugin, {});
  config.plugins.set(ppContent, {});
  config.plugins.set(listQueryVariables, {});
  config.plugins.set(authLocalFe, {});
  config.plugins.set(ecommerceComponents, {});
  config.plugins.set(ecommerceGtm, {
    itemIdProperty: 'label', // 'label',
    itemNameProperty: 'name', // 'name',
    brandProperty: null, // 'brands.name',
    categoryProperties: ['category.name'] // 'productType.name'
  });

  // eslint-disable-next-line no-param-reassign
  config.apollo = {
    ...config.apollo,
    disableUpload: true
  };
  return config;
}
